module.exports = __webpack_public_path__ + "2018c6b180704101fe3fe366daa3a9e4.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/headers/burger.jpg
 ** module id = 421
 ** module chunks = 0
 **/